import { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

export const isDropEnabled = createSelector(
    (state: RootState) => state.uploading,
    (uploading) => !uploading.disableDropArea
);
